import styled from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
`

export const Intro = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
`

export const Description = styled(Text)`
  color: ${props => props.theme.colors.text.muted};
`
